<template>
  <div>
    <el-row v-for="(item, index) in categoryList" :key="item.id">
      <el-col :span="4" style="line-height: 40px">
        {{item.name}}
      </el-col>
      <el-col :span="20">
        <el-tag class="tags"
          v-for="(attribute, i) in attributeList[item.attributeItemId]"
          :key="attribute.id"
          :type="attribute.selected ? '' : 'info'"
          @close="closeTag(item, i)"
          @click="clickTag(item, i)"
          :closable="!attribute.isDefault">
          {{attribute.name}}
        </el-tag>
        <!-- <el-tag
          class="tags"
          v-for="(attribute, i) in attributeList[item.attributeItemId]"
          :key="attribute"
          @close="closeTag(item, i)"
          closable>
          {{attribute}}
        </el-tag> -->
        <el-input class="inputAttr" :ref="item.attributeItemId + 'input'" v-model="editValue" @blur="inputBlur(item)" v-show="showInput[index]"></el-input>
        <el-button icon="el-icon-circle-plus-outline" type="text" @click="addNewAttribute(item)" v-show="!showInput[index]">新增属性值</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'categoryInfo', // 类目属性
  data () {
    return {
      categoryList: [],
      attributeList: {},
      editValue: '',
      showInput: []
    }
  },
  methods: {
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('类目属性填写不正确！'))
          }
        })
      })
    },
    getDataForm () {
      let arr = []
      try {
        Object.keys(this.attributeList).map(item => {
          let arrItem = {
            attributeItemId: item,
            attributeValueList: []
          }
          this.attributeList[item].map((mi, mindex) => {
            if (mi.selected) {
              mi.sort = mindex
            }
            return mi
          }).filter(af => {
            return af.selected
          }).forEach((att, i) => {
            arrItem.attributeValueList.push({
              attributeValueId: att.isNew ? '' : att.id,
              name: att.name,
              sort: att.sort
            })
          })
          arr.push(arrItem)
        })
        arr = arr.filter(item => {
          return item.attributeValueList.length
        })
      } catch (error) {
        console.log(error)
      }
      return arr
    },
    resetDataForm () {
      this.editValue = ''
      // this.$refs['dataForm'].resetFields()
    },
    setDataForm (data) {
      // data.foregroundCategoryId = data.backgroundCategoryId
      this.categoryList = data.categoryList
      this.categoryList.map(item => {
        item.editting = false
        // this.attributeList[item.attributeItemId] = []
        let arr = item.attributeValueList.map(item => {
          return {
            name: item.name,
            id: item.attributeValueId,
            isDefault: true,
            selected: !!item.selected
          }
        })
        this.$set(this.attributeList, item.attributeItemId, arr)
        this.showInput.push(false)
      })
    },
    init (node) {
      this.showInput = []
      let params = {
        backgroundCategoryId: node.backgroundCategoryId,
        companyId: this.$store.state.user.defaultCompanyId
      }
      this.$http.get(`/front/order/lclb/sparePartsShare/getItemValue`, {
        params: params
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.categoryList = data.data
            this.categoryList.map(item => {
              item.editting = false
              // this.attributeList[item.attributeItemId] = []
              let arr = item.attributeValueList.map(item => {
                return {
                  name: item.name,
                  id: item.attributeValueId,
                  isDefault: true,
                  selected: false
                }
              })
              this.$set(this.attributeList, item.attributeItemId, arr)
              this.showInput.push(false)
            })
          } else {
            this.categoryList = []
          }
        })
        .catch(() => {
          this.categoryList = []
        })
    },
    inputBlur (item) {
      if (!this.editValue) {
        this.categoryList.map((i, index) => {
          if (item.attributeItemId === i.attributeItemId) {
            this.$set(this.showInput, index, false)
          }
        })
        return
      }
      if (/\s/.test(this.editValue)) {
        this.$message.warning('请勿输入空格！')
        this.$refs[item.attributeItemId + 'input'][0].focus()
        return
      }
      if (this.attributeList[item.attributeItemId].findIndex(i => { return i.name === this.editValue }) > -1) {
        this.$message.warning('请勿重复添加！')
        this.$refs[item.attributeItemId + 'input'][0].focus()
        return
      }
      this.categoryList.map((i, index) => {
        if (item.attributeItemId === i.attributeItemId) {
          this.attributeList[item.attributeItemId].push({
            name: this.editValue,
            id: new Date().getTime(),
            isDefault: false,
            isNew: true,
            selected: true
          })
          this.$set(this.showInput, index, false)
        }
      })
      this.editValue = ''
    },
    addNewAttribute (item) {
      this.categoryList.map((i, index) => {
        if (item.attributeItemId === i.attributeItemId) {
          // this.showInput[index] = true
          this.$set(this.showInput, index, true)
        }
      })
      this.$nextTick(() => {
        this.$refs[item.attributeItemId + 'input'][0].focus()
      })
      // item.editting = true
    },
    closeTag (item, i) {
      this.attributeList[item.attributeItemId].splice(i, 1)
    },
    clickTag (item, i) {
      this.attributeList[item.attributeItemId][i].selected = !this.attributeList[item.attributeItemId][i].selected
    }
  }
}
</script>

<style lang="scss" scoped>
.inputAttr {
  width: 80px;
}
.tags {
  margin-right: 8px;
  margin-bottom: 4px;
  cursor: pointer;
}
</style>
